import React, { memo, useState, useCallback, MouseEvent } from 'react'
import { makeStyles } from '@material-ui/styles'
import AlertIcon from '@material-ui/icons/NotificationImportantOutlined'
import ButtonBase from '@material-ui/core/ButtonBase'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import CircularProgress from '@material-ui/core/CircularProgress'
import mixpanel from 'mixpanel-browser'

// import { ReactComponent as Capslock } from 'assets/images/capslock.svg'
import { Textfield } from '../'
import { AuthStore } from '../../reducer'
import styles from './styles'
import { StoreValue } from 'store'
import {
	TLoginProps,
	EAuthTextfieldType,
	EAuthActionTypes,
	EAuthSectionTypes,
	EAppStateActionTypes,
} from 'models'
import { signInWithMagicLink } from '../../../../../src/store/queries/supabse/register'
import { useCheckCredentialsLazyQuery } from 'graphql/__generated__/graphql'

const useStyles = makeStyles(styles)

const LoginView: React.FunctionComponent<TLoginProps> = props => {
	const { success, error, validation, values, dispatch, storeDispatch } =
		props

	// const { token }: { token?: string } = useParams()
	const [loginSuccess, setLoginSuccess] = useState<boolean>(false)
	const classes = useStyles()
	const [loading, toggle] = useState(false)
	const { t } = useTranslation()
	// const [fetchProfile, setFetchprofile] = useState(false)
	const recoverPassword = useCallback(() => {
		dispatch({
			type: EAuthActionTypes.setSection,
			section: EAuthSectionTypes.forgotPassword,
		})
	}, [dispatch])

	const goToSignUp = useCallback(() => {
		dispatch({
			type: EAuthActionTypes.setSection,
			section: EAuthSectionTypes.signUp,
		})
	}, [dispatch])
	const [getProfile] = useCheckCredentialsLazyQuery()
	// const [loginMutationHandle] = useMutation(LoginMutation, {
	// 	variables: {
	// 		...values,
	// 	},
	// })
	// const { data: profileData, loading: profileLoading } = useQuery(
	// 	CheckCredentialsQuery,
	// 	{
	// 		fetchPolicy: 'network-only',
	// 		skip: !fetchProfile,

	// 	},

	// )
	// const [activateMutationHandle] = useMutation(ActivateAccountMutation)
	// useEffect(() => {

	// 	if (fetchProfile && profileData) {
	// 		setFetchprofile(false)

	// 		const newData = {

	// 			...profileData.checkCredentials,
	// 			profile: {
	// 				...profileData.checkCredentials.profileCollection.edges[0]?.node,
	// 				ownedCompanies: profileData.checkCredentials._UserToCompanyRoleCollection.edges[0]?.node
	// 			}
	// 		}
	// 		storeDispatch({
	// 			type: EAppStateActionTypes.updateUser,
	// 			user: newData,
	// 		});
	// 	}
	// }, [fetchProfile, profileData])
	const goToLogin = useCallback(
		async (e: MouseEvent<HTMLButtonElement>) => {
			e.preventDefault()
			toggle(true)
			try {
				const data: any = await signInWithMagicLink(
					values.email,
					// password: values.password,
				).then(async res => {
					// setFetchprofile(true)
					const response = JSON.parse(res)

					// localStorage.setItem(
					// 	cleanHeaderName(TOKEN_HEADER),
					// 	response?.session?.access_token,
					// )
					// localStorage.setItem(
					// 	cleanHeaderName(REFRESH_TOKEN_HEADER),
					// 	response?.session?.refresh_token,
					// )
					const { data: profileData } = await getProfile({
						fetchPolicy: 'network-only',
					})

					storeDispatch({
						type: EAppStateActionTypes.updateUser,
						user: profileData?.checkCredentials,
					})
					if (response) {
						setLoginSuccess(true)
						dispatch({
							type: EAuthActionTypes.setEmail,
							email: '',
						})
					}

					// setTimeout(() => {
					// window.location.href =
					// 	JSON.parse(res)?.config?.data?.personalization?.[0]
					// 		?.macros?.MAGIC_LINK || '/'
					// }, 2000)
				})

				if (data?.user) {
					mixpanel.identify(data.user.user_metadata.id)
					mixpanel.people.set({
						$first_name: data.user.user_metadata.firstName,
						$last_name: data.user.user_metadata.lastName,
						$email: data.user.user_metadata.email,
					})
				}

				// if (data) {
				// 	await firebaseApp
				// 		.auth()
				// 		.signInWithCustomToken(data.session.access_token)
				// 		.then((firebaseUser: any) => {
				// 			storeDispatch({
				// 				type: EAppStateActionTypes.updateUser,
				// 				user: data.user,
				// 				firebaseUser,
				// 			});
				// 		})
				// 		.catch((err: any) => {
				// 			console.error("Firebase auth error:", err);
				// 		});
				// } else {
				// 	dispatch({
				// 		type: EAuthActionTypes.authFailed,
				// 	});
				// 	toggle(false);
				// }
			} catch (error) {
				console.error('Error during login:', error)
				dispatch({
					type: EAuthActionTypes.authFailed,
				})
				toggle(false)
			}
			toggle(false)
		},
		[dispatch, values, storeDispatch, getProfile],
	)

	// useEffect(() => {
	// 	if (typeof token !== 'undefined') {

	// 		const activateHandle = async () => {
	// 			const { data }: any = await activateMutationHandle({
	// 				variables: {
	// 					token,
	// 					language: i18n.language,
	// 				},
	// 			})

	// 			if (data.login.user.user_metadata && data.login.user.user_metadata.email_verified)
	// 				dispatch({
	// 					type: EAuthActionTypes.setActivationSuccess,
	// 				})
	// 			else
	// 				dispatch({
	// 					type: EAuthActionTypes.setActivationError,
	// 				})
	// 			history.replace(`/${i18n.language}/auth`)
	// 		}
	// 		activateHandle()
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [])

	return (
		<>
			<div className={classes.errorMessagesContainer}>
				{loginSuccess && (
					<div className={classes.accountConfirmation}>
						{
							// t('Account verified successfully!') +
							// 	'\n' +
							t('Please check your email.')
						}
					</div>
				)}
				{success.signUp && (
					<div className={classes.accountConfirmation}>
						{t('Account was created successfully!') +
							'\n' +
							t(
								'Please check your email and activate your account',
							)}
					</div>
				)}
				{success.activation && (
					<div className={classes.accountConfirmation}>
						{t('Account activated successfully!') +
							'\n' +
							t('Yey ... you can now login')}
					</div>
				)}
				{success.updateForgotPassword && (
					<div className={classes.accountConfirmation}>
						{t('Password changed successfully!')}
					</div>
				)}
				{error.login && (
					<div
						className={classNames([
							classes.accountConfirmation,
							classes.messageWithIcon,
						])}
					>
						<AlertIcon />
						<span>
							{t(
								'Your email address or password is incorrect. Please try again',
							)}
						</span>
					</div>
				)}
				{error.activation && (
					<div
						className={classNames([
							classes.accountConfirmation,
							classes.messageWithIcon,
						])}
					>
						<AlertIcon />
						<span>
							{t('Account activation failed!') +
								'\n' +
								t('Are you sure you have the correct data?')}
						</span>
					</div>
				)}
				{/*capslock && <div className={classes.capslockWarning}>
						<Capslock />
						Caps Lock is on
					</div>*/}
			</div>
			<form className={classes.form}>
				<div className={classes.container}>
					<Textfield type={EAuthTextfieldType.email} name={'email'} />
					{/*<Textfield
						type={EAuthTextfieldType.password}
						name={'password'}
					/>*/}
					<ButtonBase
						className={classes.forgotPasswordLink}
						onClick={recoverPassword}
					>
						{t('Forgot your password?')}
					</ButtonBase>
					<ButtonBase
						type="submit"
						className={classNames(classes.loginButton, {
							[classes.loginButtonActive]:
								validation.email &&
								validation.password &&
								!loading,
						})}
						disabled={!validation.email || loading}
						onClick={goToLogin}
					>
						{!loading && 'LOG IN'}
						{loading && (
							<CircularProgress
								className={classes.loading}
								size={20}
							/>
						)}
					</ButtonBase>
					{/*<div className={classes.authDelimiter}>
						<hr />
						<span>OR</span>
						<hr />
					</div>*/}
					{/*<div className={classes.socialLinks}>
						<LinkedinLogin loading={loading} toggle={toggle} />
						<GoogleLogin loading={loading} toggle={toggle} />
						<FacebookLogin loading={loading} toggle={toggle} />
					</div>*/}
				</div>
			</form>
			<div className={classes.createAccount}>
				<span>{t("You don't have an account?")}</span>
				<ButtonBase onClick={goToSignUp}>
					{t('Sign up now!')}
				</ButtonBase>
			</div>
		</>
	)
}

const LoginFormWithAuthStore = (props: any) => (
	<AuthStore keys={['success', 'error', 'validation', 'values', 'dispatch']}>
		<LoginView {...props} />
	</AuthStore>
)
export default memo((props: any) => (
	<StoreValue keys={['firebase', 'storeDispatch']}>
		<LoginFormWithAuthStore {...props} />
	</StoreValue>
))
